import React from 'react';

const InvestmentRecovery = () => {
  return (
    <section className="investment-recovery">
      <div className="container">
        <a href="https://pay.kiwify.com.br/TXv8v09" target="_blank" rel="noopener noreferrer" className="recovery-cta-button">
          Sim, quero começar agora!
        </a>
        
        <div className="recovery-box">
          <div className="recovery-header">
            <p className="recovery-main-text">
              Recupere o Valor investido fazendo APENAS 2 Procedimentos, isso é menos de 2H de trabalho.
            </p>
          </div>
          
          <div className="recovery-content">
            <div className="recovery-icon">
              <svg viewBox="0 0 120 120" width="100" height="100">
                {/* Clock circle */}
                <circle cx="60" cy="60" r="50" fill="none" stroke="#FFD700" strokeWidth="4"/>
                {/* Clock hands */}
                <line x1="60" y1="60" x2="60" y2="30" stroke="#FFD700" strokeWidth="3" strokeLinecap="round"/>
                <line x1="60" y1="60" x2="80" y2="60" stroke="#FFD700" strokeWidth="2" strokeLinecap="round"/>
                {/* Circular arrow */}
                <path d="M 60 20 A 40 40 0 1 1 60 100" stroke="#FFD700" strokeWidth="3" fill="none" strokeLinecap="round"/>
                <path d="M 55 25 L 60 20 L 65 25" stroke="#FFD700" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                {/* Dollar sign */}
                <text x="60" y="75" fontSize="32" fill="#FFD700" fontWeight="900" textAnchor="middle" fontFamily="Arial, sans-serif">$</text>
              </svg>
            </div>
            
            <div className="recovery-details">
              <div className="recovery-item">
                <p className="recovery-label">Valor investido no Curso</p>
                <p className="recovery-value">R$ 77,90</p>
              </div>
              
              <div className="recovery-item">
                <p className="recovery-label">Valor médio de 1 Procedimento</p>
                <p className="recovery-value">R$50,00 a R$80,00</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="recovery-question">
          <h2 className="recovery-question-text">ESTÁ PRONTA PARA FAZER TRABALHOS INCRÍVEIS COMO ESSES?</h2>
          <div className="section-divider"></div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentRecovery;

